import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-95c82504"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "identity-title-text" };
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        text: { default: "" }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.text), 1));
        };
    }
});
